import React, { useEffect, useId, useState } from "react";
import { Card, Placeholder } from "react-bootstrap";
import MainCard from "../Cards/MainCard";

const KPICardSkeleton = () => {
  return (
    <MainCard>
      <Card.Body className="d-flex flex-column justify-content-between p-0">
        {/* Top Row */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          {/* Icon Box */}
          <Placeholder
            as="div"
            animation="wave"
            className="rounded"
            style={{ width: "40px", height: "40px" }}
          />
          {/* Trend */}
          <Placeholder xs={2} animation="wave" />
        </div>

        {/* Middle Row - Value */}
        <Placeholder as="h3" animation="wave" className="fw-bold mb-1">
          <Placeholder xs={4} />
        </Placeholder>

        {/* Bottom Row - Title */}
        <Placeholder as="p" animation="wave" className="small mb-0">
          <Placeholder xs={6} />
        </Placeholder>
      </Card.Body>
    </MainCard>
  );
};

export default KPICardSkeleton;
